export default __webpack_public_path__ + "static/julie@2x-3b84a7459b05e0f7afc54cab22403efc.png";